import { createNewTradingAccount } from "../../utils/apiClient";
import { AccountType } from "../../utils/enums";

/**
 * Create a new DEMO trading account.
 *
 * Uses API: /v1/user/create-new-trading-account
 * BODY: { ACCOUNT_TYPE: 2 }
 * Wrapped by apiClient.createNewTradingAccount, which:
 * - Builds MESSAGES: { HEADERS: {{extra_infos}}, BODY: { ACCOUNT_TYPE } }
 * - Sends Authorization Bearer token in the main headers (like Postman).
 *
 * @param {object} options Optional options passed to apiClient (e.g. baseURL).
 * @returns {Promise<any>} Raw apiClient response ({ decryptedData, ... }).
 */
export const createDemoTradingAccount = async (options = {}) => {
  return createNewTradingAccount(AccountType.DEMO, options);
};

export default {
  createDemoTradingAccount,
};

